import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { Topic } from '@typings/show';

type InitialState = {
  byId: Record<string, Topic>;
};

export const initialState: InitialState = {
  byId: {},
};

export const topicsSlice = createSlice({
  name: 'topics',
  initialState,
  reducers: {
    setTopicDataById: (state, action: PayloadAction<Topic>) => {
      const oldTopicData = state.byId[action.payload.id] || {};
      state.byId[action.payload.id] = { ...oldTopicData, ...action.payload };
    },
    setTopicsData: (state, action: PayloadAction<Topic[]>) => {
      action.payload.forEach((topic) => {
        const previousData = state.byId[topic.id] || {};
        state.byId[topic.id] = { ...previousData, ...topic };
      });
    },
  },
});

export const { setTopicDataById, setTopicsData } = topicsSlice.actions;

export default topicsSlice.reducer;
